import {
  Text,
  VStack,
  Heading,
  ButtonGroup,
  Button,
  Flex,
  Box,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import AddProjectButtons from "../AddProjectButtons";
import { useFeatureFlags } from "../../context/featureFlagsContext";
import DynamicLoginButton from "../DynamicLoginButton";

interface WelcomeProps {
  isAuthenticated?: boolean;
}

function Welcome({ isAuthenticated = false }: WelcomeProps) {
  const { featureFlags } = useFeatureFlags();
  const showTraditionalLogin = featureFlags?.SHOW_TRADITIONAL_LOGIN;

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      w="100%"
      m={0}
      px={{ base: 4, md: 0 }}
    >
      <Box
        bg="white"
        borderRadius={{ base: "xl", md: "2xl" }}
        boxShadow="0 8px 32px rgba(46,147,255,0.10)"
        p={{ base: 6, md: 14 }}
        maxW="760px"
        w="100%"
        mx={{ base: 2, md: 0 }}
      >
        <VStack
          spacing={{ base: 6, md: 10 }}
          maxWidth="100%"
          marginTop={0}
          px={0}
        >
          <Heading
            as="h1"
            size={{ base: "lg", md: "xl" }}
            textAlign="center"
            fontWeight="extrabold"
            lineHeight={{ base: "1.2", md: "1.3" }}
          >
            Welcome to the{" "}
            <Box as="span" color="#2E93FF">
              EarthFast
            </Box>{" "}
            Dashboard
          </Heading>
          <Text
            fontSize={{ base: "sm", md: "md" }}
            textAlign="center"
            fontStyle={"italic"}
            color="gray.600"
            lineHeight={1.7}
            px={{ base: 2, md: 0 }}
          >
            EarthFast provides fully decentralized frontend hosting with
            community governance and a global network of node operators. Visit{" "}
            <Link
              style={{ color: "#2E93FF", fontWeight: 600, marginLeft: "4px" }}
              target="_blank"
              to="https://earthfast.com"
            >
              EarthFast.com
            </Link>{" "}
            for more information.
          </Text>
          <Text
            fontSize={{ base: "sm", md: "lg" }}
            textAlign="center"
            color="gray.700"
            lineHeight={1.7}
            px={{ base: 2, md: 0 }}
          >
            Create and manage website projects on EarthFast effortlessly. There
            are no prerequisites to creating projects via this dashboard. No
            blockchain experience and no tokens necessary. Just dive in and
            start hosting your website or frontend on EarthFast today!
          </Text>
          {isAuthenticated ? (
            <>
              <Text
                fontSize={{ base: "sm", md: "lg" }}
                textAlign="center"
                lineHeight={1.7}
                px={{ base: 2, md: 0 }}
              >
                Get started by adding a new project!
              </Text>
              <AddProjectButtons
                buttonProps={{ size: { base: "md", md: "lg" } }}
              />
            </>
          ) : (
            <>
              <Text
                fontSize={{ base: "sm", md: "md" }}
                textAlign="center"
                lineHeight={1.7}
                px={{ base: 2, md: 0 }}
              >
                Sign Up for a free account or Log In to get started!
              </Text>
              <ButtonGroup>
                {showTraditionalLogin ? (
                  <Button
                    as={Link}
                    to="/signin"
                    variant="primary"
                    size={{ base: "md", md: "lg" }}
                    px={{ base: 8, md: 10 }}
                  >
                    Log in or Sign up
                  </Button>
                ) : (
                  <DynamicLoginButton />
                )}
              </ButtonGroup>
            </>
          )}
        </VStack>
      </Box>
    </Flex>
  );
}

export default Welcome;
